module.exports = __webpack_public_path__ + "static/ignore-everybody-77e151da44257e5fc08c24cc33fbbeb9.jpg";